module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6 text-left"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("\n                                    Nova Integradora\n                                    "), _c('i', {
    staticClass: "fa fa-angle-right"
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('dw-table-header', {
    attrs: {
      "size": _vm.size,
      "pagination": _vm.list
    },
    on: {
      "finish": _vm.updateSize
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-md"
  }, [_c('dw-table-head', {
    attrs: {
      "headers": _vm.headers,
      "editable": true
    },
    on: {
      "update": _vm.sort
    }
  }), _vm._v(" "), _c('tbody', _vm._l((_vm.list.rows), function(item) {
    return _c('tr', {
      key: item.toString('hex')
    }, [_c('td', {
      attrs: {
        "data-label": _vm.headers[0].name
      }
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[1].name
      }
    }, [_vm._v("\n                                  " + _vm._s(item.nome) + "\n\n                                  "), (item.ativo) ? _c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v("Ativo")]) : _c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v("Inativo")])]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.headers[2].name
      }
    }, [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          _vm.edit(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.remove(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-alt"
    })])])])
  }))], 1), _vm._v(" "), _c('dw-pagination', {
    attrs: {
      "pagination": _vm.list,
      "page": _vm.page,
      "offset": _vm.size
    },
    on: {
      "update": _vm.fetchData
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6377c48e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/integrator/List.vue
// module id = 876
// module chunks = 1